import React, { Component } from 'react';
import { Carousel } from 'react-responsive-carousel';
import { colors } from './modules/theme';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import SplitText from 'react-pose-text';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

// Full React Pose Text documentation can be found at
// https://popmotion.io/pose/api/react-pose-text
const charPoses = {
    exit: { opacity: 0, y: -2 },
    enter: {
        opacity: 1,
        y: 0,
        delay: ({ wordIndex }) => wordIndex * 250,
    },
};

const legendParaStyle = {
    margin: 1,
    textAlign: 'center',
    fontColor: 'white',
    fontSize: '0.9em',
};

function CarouselScreen({ imagePath, altText, legendText }) {
    return (
        <div style={{}}>
            <div style={{}}>
                <img
                    src={imagePath}
                    alt={altText}
                    className="yours-custom-class"
                    style={{ height: '90vh', width: 'auto' }}
                    onClick={() => {
                        console.log('you clicked me!');
                    }}
                />
            </div>

            <div className="legend" style={{ fontSize: '1em' }}>
                {legendText}
            </div>
        </div>
    );
}

function TappyHand({ svgPath, altText, width }) {
    return (
        <div
            style={{
                position: 'absolute',
                top: '50%',
                left: '55%',
                zIndex: '10',
            }}
            className="tappy-hand"
        >
            <img src={svgPath} alt={altText} style={{ width: width }} />
        </div>
    );
}

function CarouselItemHeader({
    titleLine1,
    titleLine2,
    subtitle,
    color,
    animate,
}) {
    return (
        <div
            style={{
                position: 'absolute',
                top: '13%',
                zIndex: '10',
                display: 'grid',
                justifyItems: 'center',
                width: '100vw',
                color: color,
                textAlign: 'center',
            }}
        >
            <div style={{ paddingLeft: 20, paddingRight: 20 }}>
                <div
                    style={{
                        fontSize: '1.2em',
                        display: 'block',
                        fontWeight: '500',
                        marginBottom: 15,
                    }}
                >
                    {animate ? (
                        <SplitText
                            initialPose="exit"
                            pose="enter"
                            charPoses={charPoses}
                        >
                            {titleLine1}
                        </SplitText>
                    ) : (
                        <p style={{ margin: 0 }}>{titleLine1}</p>
                    )}
                </div>

                {subtitle && (
                    <p style={{ marginTop: 0, textAlign: 'center' }}>
                        {subtitle}
                    </p>
                )}
            </div>
        </div>
    );
}

class IntroCarousel extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedItem: 0,
        };
    }

    componentDidMount() {
        // TODO: Uncomment line below in production
        localStorage.setItem('hasSeenTutorial', true);
    }

    render() {
        addCenterText(this.state);

        return (
            <div style={{ backgroundColor: 'black' }}>
                <div
                    style={{
                        position: 'absolute',
                        top: 0,
                        width: '100%',
                        display: 'flex',
                        justifyContent: 'flex-end',
                        color: 'white',
                        zIndex: 10,
                    }}
                >
                    <span
                        style={{
                            marginRight: '10px',
                            marginTop: '10px',
                            opacity: 0.7,
                            cursor: 'pointer',
                        }}
                        onClick={this.props.endTutorial}
                    >
                        <FontAwesomeIcon icon={faTimes} />
                    </span>
                </div>
                {this.state.selectedItem === 0 && (
                    <>
                        <CarouselItemHeader
                            titleLine1="Welcome to Introspect"
                            subtitle="Vocalise, reflect and find
                            release"
                            color={colors.transparentWhite}
                            animate={false}
                        />
                        <TappyHand
                            //svgPath={'./images/tap.svg'}
                            alt="tapping hand"
                            width="60px"
                        />
                    </>
                )}
                {this.state.selectedItem === 1 && (
                    <CarouselItemHeader
                        titleLine1="Tell me about your day"
                        subtitle=""
                        color={colors.speakingPurple}
                        animate={true}
                    />
                )}
                {this.state.selectedItem === 3 && (
                    <CarouselItemHeader
                        titleLine1="Having heard that back, what are you thinking?"
                        subtitle=""
                        color={colors.playbackLavender}
                        animate={true}
                    />
                )}
                {this.state.selectedItem === 4 && (
                    <TappyHand
                        //svgPath={'./images/tap.svg'}
                        alt="tapping hand"
                        width="40px"
                    />
                )}
                {this.state.selectedItem === 5 && (
                    <TappyHand
                        //svgPath={'./images/hold.svg'}
                        alt="tapping hand"
                        width="25px"
                    />
                )}
                <Carousel
                    showThumbs={false}
                    selectedItem={this.state.selectedItem}
                    showStatus={true}
                    dynamicHeight={true}
                    onClickItem={() => {
                        this.state.selectedItem === 5
                            ? this.props.endTutorial()
                            : this.setState({
                                  selectedItem: this.state.selectedItem + 1,
                              });
                    }}
                    onChange={currentSlide => {
                        this.setState({ selectedItem: currentSlide });
                    }}
                    infiniteLoop={false}
                    statusFormatter={(current, total) => {
                        // console.log(`current slaaade is ${current}`);
                        return `${current} of ${total}`;
                    }}
                >
                    <CarouselScreen
                        imagePath="/images/intro-screens/1_.gif"
                        altText="intro screen"
                        legendText={<div>
                            <p style={legendParaStyle}> 
                                This app is best used in a
                            </p>
                            <p style={legendParaStyle}> 
                                 quiet environment
                            </p>
                        </div>}
                    />
                    <CarouselScreen
                        imagePath="/images/intro-screens/2.gif"
                        altText="intro screen"
                        legendText={
                            <div>
                                <p style={legendParaStyle}>
                                    The system will begin by asking
                                </p>
                                <p style={legendParaStyle}>
                                    you about your day
                                </p>
                            </div>
                        }
                    />
                    <CarouselScreen
                        imagePath="/images/intro-screens/3.gif"
                        altText="intro screen"
                        legendText={
                            <div>
                                <p style={legendParaStyle} >
                                    When you’re ready — reply to the system,
                                </p>
                                <p style={legendParaStyle}>
                                    don’t worry, take as long as you need
                                </p>
                            </div>
                        }
                    />
                    <CarouselScreen
                        imagePath="/images/intro-screens/4.gif"
                        altText="intro screen"
                        legendText={
                            <div>
                                <p style={legendParaStyle}>
                                    The system will play your recording back
                                </p>
                                <p style={legendParaStyle}>
                                    to you and then ask for your thoughts
                                </p>
                            </div>
                        }
                    />
                    <CarouselScreen
                        imagePath="/images/intro-screens/5.gif"
                        altText="intro screen"
                        legendText={
                            <div>
                                <p style={legendParaStyle}>
                                    To pause your session,
                                </p>
                                <p style={legendParaStyle}>
                                    simply tap the screen
                                </p>
                            </div>
                        }
                    />
                    <CarouselScreen
                        imagePath="/images/intro-screens/6.gif"
                        altText="intro screen"
                        legendText={
                            <div>
                                <p style={legendParaStyle}>
                                    You can also end your session
                                </p>
                                <p style={legendParaStyle}>
                                    by clicking the button below
                                </p>
                                <p style={legendParaStyle}></p>
                            </div>
                        }
                    />
                    <CarouselScreen
                        imagePath="/images/intro-screens/7.gif"
                        altText="intro screen"
                        legendText={
                            <div>
                                <p style={legendParaStyle}>
                                    Depending on the level of surrounding noise 
                                </p>
                                <p style={legendParaStyle}>
                                    Choose between default or manual buttons to move on
                                </p>
                            </div>
                        }
                    />
                </Carousel>
                <div
                    style={{
                        height: '10vh',
                        display: 'grid',
                        justifyItems: 'center',
                        alignItems: 'center',
                        color: 'white',
                        backgroundColor: 'black',
                        cursor: 'pointer',
                    }}
                    onClick={this.props.endTutorial}
                >
                    <div style={{ fontSize: '0.8em', opacity: 0.8 }}>
                        {this.state.selectedItem === 6 ? (
                            <span>
                                End Tutorial</span>
                        ) : (
                            <span>Skip Tutorial</span>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

export default IntroCarousel;

function addCenterText(state) {
    if (state.selectedItem === 0) {
        if (document.getElementsByClassName('center-text-container')[0]) {
            document.getElementsByClassName(
                'center-text-container'
            )[0].style.display = 'block';
        } else {
            setTimeout(function() {
                let carousel = document.getElementsByClassName('carousel')[0];
                if (carousel) {
                    let centreTextContainer = document.createElement('div');
                    centreTextContainer.style.position = 'absolute';
                    centreTextContainer.style.top = '50%';
                    centreTextContainer.style.left = '50%';
                    centreTextContainer.style.width = '150px';
                    centreTextContainer.style.height = 'auto';
                    centreTextContainer.className = 'center-text-container';
                    centreTextContainer.style.transform =
                        'translate(-50%, -50%)';

                    let centreText = document.createElement('p');
                    centreText.innerHTML = 'Tap the orb to begin a session';
                    centreText.style.color = 'white';
                    centreText.style.margin = 0;
                    centreText.style.textAlign = 'center';
                    centreText.className = 'appear';
                    centreTextContainer.appendChild(centreText);
                    carousel.appendChild(centreTextContainer);
                }
            }, 100);
        }
    } else {
        if (document.getElementsByClassName('center-text-container')[0]) {
            document.getElementsByClassName(
                'center-text-container'
            )[0].style.display = 'none';
        }
    }
}
